import queryString from "query-string";
import React, { useState } from "react";
import { Helmet } from "react-helmet-async";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import { useHistory } from "react-router-dom";
import TabPanel from "../../elements/tab/materialTabPanel";
import CurrencyContainer from "./CurrencyContainer";
import { useTranslation } from "react-i18next";

import { StyledTabsBody, StyledTabsHead, StyledTabsWrapper } from "../../styles/styledTabs";

const DEFAULT_TAB = "currency";

const TabsContainer = () => {
  const { t } = useTranslation("currenciesPage");
  const history = useHistory();
  let queryParams = queryString.parse(history.location.search);

  const urlForTabs = () => {
    if (!queryParams.currentTab) {
      return 0;
    }

    switch (queryParams.currentTab) {
      case "currency": {
        return 0;
      }
      case "crypto": {
        return 1;
      }
    }
  };

  const tabValue = urlForTabs();

  const handleChange = (event, newValue) => {
    if (queryParams.currentTab !== newValue) {
      history.push("?currentTab=" + newValue);
    }
  };

  return (
    <>
      <Helmet>
        <title>{t("meta.title")}</title>
      </Helmet>
      <StyledTabsWrapper>
        <StyledTabsHead className="tab-head">
          <h4 className="tab-head__title">
            {t("tabs.title")}
          </h4>
          <Tabs
            value={queryParams?.currentTab ?? DEFAULT_TAB}
            indicatorColor="secondary"
            onChange={handleChange}
            orientation="vertical"
            className="tab-head-buttons"
          >
            <Tab label={t("tabs.currency")} value="currency"/>
            <Tab label={t("tabs.crypto")} value="crypto"/>
          </Tabs>
        </StyledTabsHead>
        <StyledTabsBody className="tab-body">
          <TabPanel
            value={tabValue}
            index={0}
          >
            <CurrencyContainer type="currency"/>
          </TabPanel>
          <TabPanel
            value={tabValue}
            index={1}
          >
            <CurrencyContainer type="crypto"/>
          </TabPanel>
        </StyledTabsBody>
      </StyledTabsWrapper>
    </>
  );
};

export default TabsContainer;